/**
 * The back office's own texts (ADR 0008), apart from the portal's: its web entry carries only
 * these, and the portal's bundle none of them. Spanish is the reference catalog; every other
 * locale must provide exactly the same keys, which the compiler enforces. ICU MessageFormat.
 * The sign-in email is the server's, in the portal's catalog (email.staffLogin.*).
 */
export const es = {
  'app.name': 'Eklevo',
  'app.panel': 'Panel de administración',
  'app.title': 'Eklevo · Panel de administración',
  'common.language': 'Idioma',
  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.filters.clear': 'Quitar filtros',
  'common.error.organizationChanged':
    'Has abierto otra empresa en otra pestaña, y el panel trabaja con una sola a la vez. Vuelve a abrir esta para continuar.',
  'common.signOut': 'Cerrar sesión',
  'common.error.generic': 'Algo no ha ido bien. Vuelve a intentarlo en unos minutos.',
  'common.error.rateLimited':
    'Has hecho demasiadas peticiones seguidas. Espera un minuto y vuelve a intentarlo.',
  'common.notFound.title': 'Página no encontrada',
  'common.notFound.body': 'La página que buscas no existe.',
  'common.notFound.action': 'Ir al inicio',
  'footer.rights': '© {year} Eklevo. Uso exclusivo del equipo de Eklevo.',
  'footer.help': 'Ayuda',

  'signIn.title': 'Entrar en el panel de administración',
  'signIn.intro':
    'Solo para el equipo de Eklevo. Te enviaremos un enlace al correo y, después, te pediremos tu clave de acceso.',
  'signIn.emailLabel': 'Correo de Eklevo',
  'signIn.submit': 'Enviarme un enlace de acceso',
  'signIn.sending': 'Enviando…',
  'signIn.sent':
    'Si el correo es de una persona del equipo de Eklevo, recibirás un enlace para entrar. Caduca en 15 minutos y solo se puede usar una vez.',
  'signIn.invalidEmail': 'Escribe un correo válido.',
  'signIn.confirm.body':
    'Pulsa el botón para continuar con este enlace. Después te pediremos tu clave de acceso.',
  'signIn.confirm.submit': 'Continuar',
  'signIn.confirm.busy': 'Comprobando el enlace…',
  'signIn.linkInvalid.title': 'El enlace ha caducado o ya se ha usado',
  'signIn.linkInvalid.body': 'Pide un enlace nuevo para entrar.',
  'signIn.linkInvalid.action': 'Pedir un enlace nuevo',
  'signIn.ended.idle':
    'Tu sesión se ha cerrado tras 30 minutos sin actividad. Vuelve a entrar para continuar.',
  'signIn.ended.expired':
    'Tu sesión ha llegado a su máximo de 8 horas. Vuelve a entrar para continuar.',
  'signIn.ended.closed':
    'Tu sesión se ha cerrado: has entrado desde otro dispositivo o se ha cerrado desde la herramienta de operador. Vuelve a entrar para continuar.',
  'signIn.ended.signedOut': 'Has cerrado la sesión.',

  'passkey.title': 'Confirma que eres tú',
  'passkey.body': 'Usa tu clave de acceso: la huella, la cara o el PIN de tu dispositivo.',
  'passkey.submit': 'Usar mi clave de acceso',
  'passkey.busy': 'Esperando a tu clave de acceso…',
  'passkey.lost.summary': '¿Has perdido tu clave de acceso?',
  'passkey.lost.body':
    'Pide a la persona responsable técnica de Eklevo un permiso de registro nuevo: borrará tus claves anteriores y podrás registrar una nueva durante una hora. No hay ninguna otra forma de entrar.',
  'enroll.title': 'Registra tu clave de acceso',
  'enroll.body':
    'Para entrar en el panel necesitas una clave de acceso. Se desbloquea con la huella, la cara o el PIN de tu dispositivo, y Eklevo no guarda ninguna contraseña: solo la parte pública de la clave.',
  'enroll.hint':
    'Te recomendamos tener dos, la del ordenador y la del móvil. La segunda la podrás añadir una vez dentro.',
  'enroll.submit': 'Crear mi clave de acceso',
  'enroll.busy': 'Sigue las instrucciones de tu dispositivo…',
  'enroll.done.title': 'Clave de acceso registrada',
  'enroll.done.body': 'Ahora úsala para entrar.',
  'enroll.done.submit': 'Entrar con mi clave de acceso',
  'enrollmentRequired.title': 'Todavía no tienes ninguna clave de acceso',
  'enrollmentRequired.body':
    'Para registrar la primera necesitas un permiso de la herramienta de operador, que dura una hora. Pídeselo a la persona responsable técnica de Eklevo y, cuando lo tengas, pulsa «Ya tengo el permiso».',
  'enrollmentRequired.check': 'Ya tengo el permiso',
  'enrollmentRequired.stillMissing': 'Todavía no tienes ningún permiso de registro abierto.',

  'webauthn.cancelled':
    'No se ha usado ninguna clave: se ha cancelado o ha tardado demasiado. Vuelve a intentarlo.',
  'webauthn.alreadyRegistered':
    'Este dispositivo ya tiene una clave de acceso tuya. Usa esa clave, o crea la nueva en otro dispositivo.',
  'webauthn.unsupported':
    'Este navegador no puede usar claves de acceso. Usa una versión reciente de Chrome, Edge, Firefox o Safari.',
  'webauthn.noUserVerification':
    'Este dispositivo no puede comprobar que eres tú con la huella, la cara o un PIN. Activa el bloqueo de pantalla o usa otro dispositivo.',
  'webauthn.wrongAddress':
    'Desde esta dirección no se pueden usar claves de acceso. Abre el panel desde la dirección del enlace del correo.',
  'webauthn.notRecognized':
    'No hemos reconocido esta clave de acceso. Prueba con otra de tus claves; si no tienes ninguna, pide un permiso de registro nuevo.',
  'webauthn.tooManyAttempts':
    'Ha habido demasiados intentos fallidos en la última hora. Espera un rato o pide ayuda a la persona responsable técnica de Eklevo.',
  'webauthn.expired': 'La petición ha caducado. Vuelve a intentarlo.',
  'webauthn.enrollmentNotAllowed':
    'Ya no tienes ningún permiso de registro abierto: ha caducado o ya lo has usado. Pide uno nuevo.',
  'webauthn.tooManyPasskeys': 'Ya tienes el máximo de 3 claves de acceso.',
  'webauthn.failed': 'No se ha podido usar la clave de acceso. Vuelve a intentarlo.',

  'shell.skip': 'Saltar al contenido',
  'nav.label': 'Secciones del panel',
  'nav.home': 'Inicio',
  'nav.companies': 'Empresas',
  'nav.catalog': 'Cursos',
  'status.organization.active': 'Activa',
  'status.organization.suspended': 'Suspendida',
  'status.program.not_launched': 'No lanzado',
  'status.program.active': 'Activo',
  'status.program.stopped': 'Detenido',
  'status.program.completed': 'Completado',
  'status.course.draft': 'Borrador',
  'status.course.published': 'Publicado',
  'status.course.archived': 'Archivado',
  'home.title': 'Inicio',
  'home.body':
    'Las empresas de Eklevo y su catálogo de cursos, en recuentos, y la actividad del equipo. Ninguna persona de las empresas.',
  'home.stats.label': 'Indicadores',
  'home.stats.organizations': 'Empresas activas',
  'home.stats.people': 'Personas activas',
  'home.stats.peopleHint': 'De las empresas activas',
  'home.stats.courses': 'Cursos publicados',
  'home.stats.assignments': 'Asignaciones en curso',
  'home.stats.assignmentsHint': 'Sin terminar, de las personas de las empresas activas',
  'home.stats.completion': 'Finalización global',
  'home.stats.completionHint': '{count, number} de {total, number} asignaciones terminadas',
  'home.stats.completionNone': 'Todavía no hay ninguna asignación',
  'home.stats.noValue': '—',
  'home.empty.title': 'Todavía no hay ninguna empresa activa',
  'home.empty.body':
    'Da de alta la primera con el asistente: sus datos, su equipo de RRHH, su aviso informativo y sus cursos.',
  'home.empty.add': 'Añadir nueva empresa',
  'home.go.label': 'Accesos rápidos',
  'home.go.companies':
    'Dar de alta una empresa, editarla, su equipo de RRHH, y suspenderla o reactivarla.',
  'home.go.catalog': 'El catálogo de Eklevo, y activar un curso en una empresa.',
  'home.access.title': 'Tu acceso',
  'home.session.title': 'Tu sesión',
  'home.session.endsAt':
    'Termina como muy tarde a las {endsAt, time, short}, y antes si pasas 30 minutos sin actividad.',
  'home.passkeys.title': 'Tus claves de acceso',
  'home.passkeys.count':
    '{count, plural, one {Tienes # clave de acceso, de un máximo de 3.} other {Tienes # claves de acceso, de un máximo de 3.}}',
  'home.passkeys.hint':
    'Te recomendamos dos, la del ordenador y la del móvil. Si pierdes un dispositivo, avisa a la persona responsable técnica de Eklevo.',
  'home.passkeys.add': 'Añadir una clave de acceso',
  'home.passkeys.createTitle': 'Crea la clave nueva',
  'home.passkeys.createBody':
    'Créala en este dispositivo o, con el código QR que te muestre el navegador, en tu móvil.',
  'home.passkeys.create': 'Crear la clave nueva',
  'home.passkeys.added':
    '{count, plural, one {Clave añadida. Ahora tienes # clave de acceso.} other {Clave añadida. Ahora tienes # claves de acceso.}}',
  'home.passkeys.full': 'Ya tienes el máximo de 3 claves de acceso.',
  'home.activity.title': 'Actividad reciente del equipo de Eklevo',
  'home.activity.body':
    'Las últimas acciones del equipo, en el panel y con la herramienta de operador. Nunca las de las personas de las empresas.',
  'home.activity.empty': 'Todavía no hay actividad del equipo.',
  'home.activity.someone': 'Una persona del equipo',
  'home.activity.at': '{at, date, medium}, {at, time, short}',
  'home.activity.organization.created': 'ha dado de alta {company}.',
  'home.activity.organization.updated': 'ha editado los datos de {company}.',
  'home.activity.organization.brand_set': 'ha cambiado la marca de {company}.',
  'home.activity.organization.suspended': 'ha suspendido {company}.',
  'home.activity.organization.reactivated': 'ha reactivado {company}.',
  'home.activity.program.activated': 'ha activado «{course}» en {company}.',
  'home.activity.person.invited': 'ha reenviado una invitación del equipo de RRHH de {company}.',
  'home.activity.course.created': 'ha creado el curso «{course}».',
  'home.activity.course.published': 'ha publicado «{course}».',
  'home.activity.course.corrected': 'ha corregido «{course}».',
  'home.activity.course.imported': 'ha cargado una versión de «{course}».',
  'home.activity.course.archived': 'ha archivado «{course}».',
  'home.activity.course.duplicated': 'ha duplicado un curso en «{course}».',
  'home.activity.untitledCourse': 'Curso sin título',
  'home.activity.goneCourse': 'Curso que ya no existe',
  'home.noa.title': 'Noa',
  'home.noa.body':
    'Las empresas que este mes han pasado del 80 % de su tope de Noa, y las que la tienen en pausa. Nunca el importe: lo da la herramienta de operador.',
  'home.noa.empty': 'Ninguna empresa ha pasado del 80 % de su tope ni tiene Noa en pausa.',
  'home.noa.warning': 'Ha pasado del 80 % de su tope de este mes.',
  'home.noa.paused': 'Ha llegado a su tope: Noa está en pausa hasta el mes que viene.',
  'home.noa.updating': 'Noa está en pausa por una actualización: hay que volver a activarla.',

  'companies.title': 'Empresas',
  'companies.body':
    'Nombre, estado y recuentos de cada empresa. La lista no muestra ninguna persona.',
  'companies.add': 'Añadir empresa',
  'companies.filters.label': 'Buscar y filtrar empresas',
  'companies.search': 'Buscar empresas',
  'companies.filter.status': 'Estado',
  'companies.filter.allStatuses': 'Todos los estados',
  'companies.count': '{count, plural, one {# empresa} other {# empresas}}',
  'companies.empty.title': 'Todavía no hay ninguna empresa',
  'companies.empty.body': 'Da de alta la primera con «Añadir empresa».',
  'companies.noResults': 'Ninguna empresa coincide con la búsqueda y el filtro.',
  'companies.open': 'Ver detalle',
  'companies.openLabel': 'Ver detalle de {company}',
  'company.counts': 'Recuentos',
  'company.activePeople': 'Personas activas',
  'company.invitedPeople': 'Invitadas sin entrar',
  'company.hrPeople': 'Equipo de RRHH',
  'company.departments': 'Departamentos',
  'company.activeCourses': 'Cursos activos',
  'company.activeCoursesHint':
    '«Cursos activos» cuenta los que RRHH ya ha lanzado; uno recién activado queda «No lanzado».',
  'company.back': 'Todas las empresas',
  'company.audited':
    'Abrir esta ficha queda en el registro de auditoría de la empresa, como editarla, ver su equipo de RRHH, reenviarle una invitación, suspenderla, reactivarla o activarle un curso.',
  'company.notFound.title': 'Esta empresa no existe o ya no está disponible',
  'company.notFound.body': 'Puede que se haya dado de baja. Vuelve a la lista de empresas.',
  'company.reopen': 'Volver a abrir esta empresa',
  'company.courses.title': 'Cursos de Eklevo activados',
  'company.courses.empty': 'Todavía no tiene ningún curso de Eklevo activado.',
  'company.courses.toCatalog': 'Activar un curso desde «Cursos»',
  'company.noa.title': 'Noa',
  'company.noa.state.on': 'Activa',
  'company.noa.state.off': 'Desactivada',
  'company.noa.state.updating': 'En pausa por una actualización',
  'company.noa.state.paused': 'En pausa por el tope',
  'company.noa.on': 'Noa responde a las personas de la empresa.',
  'company.noa.off':
    'Noa no está activada en esta empresa. La activa el equipo de Eklevo con la herramienta de operador, después de la revisión especialista.',
  'company.noa.updating':
    'Noa funciona ahora con versiones distintas de las validadas al activarla en esta empresa. Hasta que se vuelva a activar con las nuevas, después de pasar las frases trampa en el entorno de pruebas, solo responde el filtro de crisis.',
  'company.noa.paused':
    'Ha llegado a su tope de este mes: hasta el mes que viene solo responde el filtro de crisis.',
  'company.noa.warning': 'Este mes ha pasado del 80 % de su tope.',
  'company.noa.validated': 'Validada con',
  'company.noa.running': 'Versiones en marcha',
  'company.noa.prompt': 'Prompt',
  'company.noa.crisisTerms': 'Lista de crisis',
  'company.noa.model': 'Modelo',
  'company.noa.validatedAt': 'Activada',
  'company.noa.at': '{at, date, medium}, {at, time, short}',
  'company.noa.unknown': 'Desconocido',
  'company.noa.amount': 'El tope y el importe exactos solo los da la herramienta de operador.',
  'company.passkeyNote': 'Te pediremos tu clave de acceso para confirmarlo.',
  'company.suspend': 'Suspender',
  'company.suspend.title': '¿Suspender {company}?',
  'company.suspend.body':
    'Todas las personas de la empresa pierden el acceso a Eklevo ahora mismo, al portal y a la consola de RRHH, también quien tenga la sesión abierta, y los enlaces de acceso ya enviados dejan de servir. Hasta que la reactives. Sus datos no cambian.',
  'company.suspend.busy': 'Suspendiendo…',
  'company.suspended': 'Empresa suspendida: nadie de la empresa puede entrar.',
  'company.reactivate': 'Reactivar',
  'company.reactivate.title': '¿Reactivar {company}?',
  'company.reactivate.body':
    'Las personas de la empresa podrán volver a entrar con un enlace de acceso, con todo lo que tenían.',
  'company.reactivate.busy': 'Reactivando…',
  'company.reactivated': 'Empresa reactivada: sus personas ya pueden volver a entrar.',
  'company.error.unchanged': 'Otra persona del equipo ya había hecho este cambio.',
  'company.created':
    '{count, plural, =0 {Empresa creada. El equipo de RRHH recibirá la invitación en unos minutos.} one {Empresa creada. El equipo de RRHH recibirá la invitación en unos minutos, y el curso espera «No lanzado» hasta que RRHH lo lance.} other {Empresa creada. El equipo de RRHH recibirá la invitación en unos minutos, y los cursos esperan «No lanzado» hasta que RRHH los lance.}}',
  'company.data.title': 'Datos de la empresa',
  'company.data.locale': 'Idioma por defecto',
  'company.data.timeZone': 'Zona horaria',
  'company.data.brand': 'Colores de marca',
  'company.data.brand.none': 'Los de Eklevo',
  'company.data.logo': 'Logo',
  'company.data.logo.alt': 'Logo de {company}',
  'company.data.logo.none': 'Sin logo',
  'company.data.legalName': 'Nombre legal',
  'company.data.taxId': 'CIF/NIF',
  'company.data.address': 'Dirección',
  'company.data.privacyContact': 'Contacto de privacidad',
  'company.data.none': 'Sin indicar',
  'company.edit': 'Editar',
  'company.edit.title': 'Editar los datos de la empresa',
  'company.edit.intro':
    'Los cambios se ven desde ahora en el portal y en la consola de RRHH de la empresa. El nombre y la zona horaria también cuentan en los correos que salgan y en los diplomas que se descarguen a partir de ahora.',
  'company.edit.legal.hint': 'Opcionales. Si dejas uno en blanco, se quita.',
  'company.edit.save': 'Guardar cambios',
  'company.edit.busy': 'Guardando…',
  'company.edit.saved': 'Datos de la empresa guardados.',
  'company.edit.purpose': 'Guardar los cambios de {company}.',
  'company.edit.unchanged': 'No hay ningún cambio que guardar.',
  'company.edit.problems': 'Revisa los campos marcados.',
  'company.edit.logo.kept': 'La empresa tiene logo.',
  'company.edit.logo.removed': 'Se quitará el logo al guardar.',
  'company.edit.logo.undo': 'Mantener el logo',
  'company.edit.noticeMissing':
    'La última versión del aviso informativo de esta empresa no está en este idioma. Publica antes una versión que lo incluya, con la herramienta de operador («org notice»), y vuelve a cambiarlo.',
  'company.edit.stale':
    'Otra persona ha guardado cambios en los datos de la empresa mientras los editabas, y los tuyos no se han guardado. Estos son los datos actuales: vuelve a «Editar» si quieres cambiarlos.',
  'company.hr.title': 'Equipo de RRHH',
  'company.hr.body':
    'Solo las personas con el rol de RRHH, invitadas o activas: el único lugar del panel con nombres y correos. Cada vez que se muestra queda en el registro de auditoría de la empresa.',
  'company.hr.empty': 'La empresa no tiene ninguna persona de RRHH invitada ni activa.',
  'company.hr.status.active': 'Activa',
  'company.hr.status.invited': 'Invitada',
  'company.hr.invitation.usable': 'Invitación enviada el {at, date, medium}',
  'company.hr.invitation.expired': 'La última invitación, del {at, date, medium}, ya no sirve',
  'company.hr.invitation.none': 'Todavía no se le ha enviado ninguna invitación',
  'company.hr.resend': 'Reenviar invitación',
  'company.hr.send': 'Enviar invitación',
  'company.hr.resend.busy': 'Enviando…',
  'company.hr.confirm.resend':
    'Le llegará un correo con un enlace nuevo para entrar, y el de la invitación anterior dejará de servir. Como mucho 3 al día por persona.',
  'company.hr.confirm.send':
    'Le llegará un correo con un enlace para entrar. Como mucho 3 al día por persona.',
  'company.hr.resent': 'Invitación enviada. Llegará en unos minutos, y la anterior deja de servir.',
  'company.hr.noNotice':
    'La empresa todavía no tiene aviso informativo: no sale ninguna invitación hasta que lo tenga.',
  'company.hr.error.limit':
    'Esta persona ya ha recibido 3 invitaciones hoy. Vuelve a intentarlo mañana.',
  'company.hr.error.notInvitable': 'Esta persona ya ha entrado: no necesita ninguna invitación.',
  'company.hr.error.notFound': 'Esta persona ya no está en el equipo de RRHH de la empresa.',
  'company.hr.suspended': 'La empresa está suspendida: reactívala para enviar invitaciones.',
  'catalog.title': 'Cursos',
  'catalog.body':
    'El catálogo de Eklevo. Un curso publicado se activa empresa por empresa, y queda «No lanzado» hasta que RRHH lo lanza.',
  'catalog.filters.label': 'Buscar y filtrar cursos',
  'catalog.search': 'Buscar cursos',
  'catalog.filter.level': 'Nivel',
  'catalog.filter.allLevels': 'Todos los niveles',
  'catalog.empty.title': 'Todavía no hay ningún curso en el catálogo',
  'catalog.empty.body':
    'Crea el primero con «Crear nuevo curso», o cárgalo con la herramienta de operador.',
  'catalog.noResults': 'Ningún curso coincide con la búsqueda y el filtro.',
  'catalog.untitled': 'Curso sin título',
  'catalog.level': 'Nivel {level}',
  'catalog.lessons': '{count, plural, one {# lección} other {# lecciones}}',
  'catalog.duration': '{minutes, number} min',
  'catalog.activeIn':
    '{count, plural, =0 {No está activo en ninguna empresa} one {Activo en # empresa} other {Activo en # empresas}}',
  'catalog.activeInHint':
    'Cuenta las empresas en las que RRHH ya lo ha lanzado, también las suspendidas.',
  'catalog.activate': 'Activar en una empresa',
  'catalog.activate.label': 'Activar en una empresa: {course}',
  'catalog.activate.company': 'Empresa',
  'catalog.activate.choose': 'Elige una empresa',
  'catalog.activate.suspended': '{company} (suspendida)',
  'catalog.activate.hint': 'Quedará «No lanzado»: RRHH de la empresa decide cuándo lanzarlo.',
  'catalog.activate.submit': 'Activar',
  'catalog.activate.busy': 'Activando…',
  'catalog.activate.required': 'Elige una empresa.',
  'catalog.activate.done': 'Activado en {company}. Queda «No lanzado» hasta que RRHH lo lance.',
  'catalog.activate.already': '{company} ya tiene este curso.',
  'catalog.activate.purpose': 'Activar «{course}» en {company}.',
  'catalog.activate.unavailable':
    'Este curso ya no se puede activar, o la empresa ya no está disponible.',
  'catalog.activate.noCompanies': 'Todavía no hay ninguna empresa en la que activarlo.',
  'catalog.create': 'Crear nuevo curso',
  'catalog.edit': 'Editar',
  'catalog.edit.label': 'Editar «{course}»',
  'catalog.duplicate': 'Duplicar',
  'catalog.duplicate.label': 'Duplicar «{course}»',
  'catalog.duplicate.title': 'Duplicar «{course}»',
  'catalog.duplicate.body.published':
    'Crearemos un borrador nuevo con todo el contenido de la versión publicada: lecciones, evaluaciones, materiales y vídeos. El curso original no cambia.',
  'catalog.duplicate.body.draft':
    'Crearemos un borrador nuevo con todo el contenido de este borrador: lecciones, evaluaciones, materiales y vídeos. El curso original no cambia.',
  'catalog.duplicate.after':
    'El duplicado no tiene serie ni nivel ni está activo en ninguna empresa. Te avisaremos aquí cuando esté listo para que lo revises en el editor y lo publiques.',
  'catalog.duplicate.busy': 'Duplicando…',
  'catalog.duplicate.unavailable': 'Este curso ya no está disponible.',
  'catalog.duplicate.running':
    'Duplicando: se están copiando los archivos, y con vídeos grandes puede tardar unos minutos. Puedes seguir trabajando; el borrador aparecerá en «Cursos».',
  'catalog.duplicate.done': 'Duplicado: el borrador ya está en «Cursos».',
  'catalog.duplicate.open': 'Abrir el borrador',
  'catalog.duplicate.failed':
    'No se ha podido duplicar y no se ha creado ningún borrador. Vuelve a intentarlo. Código: {code}.',
  'catalog.duplicate.unknown':
    'No sabemos cómo ha terminado. Si el duplicado no aparece en «Cursos», vuelve a intentarlo.',
  'catalog.archive': 'Archivar',
  'catalog.archive.label': 'Archivar «{course}»',
  'catalog.archive.checking': 'Comprobando…',
  'catalog.archive.title': 'Archivar «{course}»',
  'catalog.archive.body':
    'Ninguna empresa nueva podrá activarlo. Un curso archivado no se edita ni se puede desarchivar, pero sí se puede duplicar.',
  'catalog.archive.companies':
    '{count, plural, =0 {Ninguna empresa lo tiene activado.} one {Lo tiene activado # empresa, que ya no podrá asignarlo a nadie más.} other {Lo tienen activado # empresas, que ya no podrán asignarlo a nadie más.}}',
  'catalog.archive.people':
    '{count, plural, =0 {Nadie lo tiene asignado sin terminar.} one {# persona lo tiene asignado sin terminar: podrá terminarlo con su versión.} other {# personas lo tienen asignado sin terminar: podrán terminarlo con su versión.}}',
  'catalog.archive.draft':
    'Se descartará el borrador abierto en el editor, con los cambios que no se han publicado.',
  'catalog.archive.changed':
    'El curso ha cambiado mientras lo confirmabas: revisa de nuevo qué pasará al archivarlo.',
  'catalog.archive.busy': 'Archivando…',
  'catalog.archive.done': '«{course}» archivado. Quien lo tenía asignado puede terminarlo.',
  'catalog.archive.unavailable': 'Este curso ya está archivado o no se ha publicado nunca.',
  'editor.publish.purpose': 'Publicar «{course}» en el catálogo.',
  'editor.notFound': 'Este curso no existe o ya no está disponible.',
  'editor.back': 'Volver a Cursos',
  'wizard.title': 'Añadir nueva empresa',
  'wizard.body':
    'Los datos de la empresa, su equipo de RRHH, su aviso informativo y los cursos con los que empieza. Lo que escribas solo se guarda en esta pestaña hasta que crees la empresa.',
  'wizard.steps.label': 'Pasos del alta',
  'wizard.step.company': 'Datos de la empresa',
  'wizard.step.people': 'Empleados',
  'wizard.step.hr': 'Equipo de RRHH',
  'wizard.step.notice': 'Aviso informativo',
  'wizard.step.courses': 'Cursos',
  'wizard.step.summary': 'Resumen',
  'wizard.step.position': 'Paso {step} de {total}',
  'wizard.step.done': 'completado',
  'wizard.step.problems': 'con datos por revisar',
  'wizard.step.pending': 'pendiente',
  'wizard.back': 'Atrás',
  'wizard.next': 'Siguiente',
  'wizard.cancel': 'Cancelar',
  'wizard.problems': 'Revisa los datos marcados en este paso para continuar.',
  'wizard.problems.server':
    'No se ha creado la empresa: hay datos por revisar en este paso. Corrígelos y vuelve a «Crear empresa».',
  'wizard.leave.title': '¿Salir sin crear la empresa?',
  'wizard.leave.body':
    'Se perderá lo que has escrito: el alta solo se guarda en esta pestaña hasta que creas la empresa.',
  'wizard.leave.stay': 'Seguir con el alta',
  'wizard.leave.confirm': 'Salir sin crear',
  'wizard.locale.es': 'Español',
  'wizard.locale.ca': 'Catalán',
  'wizard.locale.en': 'Inglés',
  'wizard.timeZone.Europe/Madrid': 'Península y Baleares (Europe/Madrid)',
  'wizard.timeZone.Atlantic/Canary': 'Canarias (Atlantic/Canary)',
  'wizard.company.intro':
    'El nombre con el que la verán sus personas, su idioma, su zona horaria y, si quieres, sus datos legales y sus colores.',
  'wizard.company.name': 'Nombre de la empresa',
  'wizard.company.name.hint': 'No puede coincidir con el de otra empresa de Eklevo.',
  'wizard.company.locale': 'Idioma por defecto',
  'wizard.company.locale.hint':
    'El de las invitaciones y el de las personas nuevas. Cada persona puede cambiar el suyo.',
  'wizard.company.timeZone': 'Zona horaria',
  'wizard.company.timeZone.hint':
    'La de las fechas límite, los recordatorios, los diplomas y los informes de la empresa.',
  'wizard.company.legal': 'Datos legales',
  'wizard.company.legal.hint': 'Opcionales: también se pueden completar después, desde «Editar».',
  'wizard.company.legalName': 'Nombre legal',
  'wizard.company.legalName.hint': 'La razón social, si es distinta del nombre de la empresa.',
  'wizard.company.taxId': 'CIF/NIF',
  'wizard.company.taxId.hint':
    'Un CIF, NIF o NIE español, o un NIF-IVA intracomunitario. El español se guarda sin «ES».',
  'wizard.company.address': 'Dirección',
  'wizard.company.address.hint': 'La de la sede de la empresa, en una línea.',
  'wizard.company.privacyContact': 'Contacto de privacidad',
  'wizard.company.privacyContact.hint':
    'El correo al que sus personas pueden escribir sobre sus datos. Mejor un buzón compartido, como privacidad@ o dpd@, que el de una persona.',
  'wizard.logo': 'Logo de la empresa',
  'wizard.logo.hint':
    'PNG o JPEG, de hasta 1 MB y entre 32 y 4.000 píxeles por lado. Opcional: sin logo, el portal y la consola muestran el de Eklevo.',
  'wizard.logo.choose': 'Elegir logo',
  'wizard.logo.ready': 'Logo listo: {file}',
  'wizard.logo.change': 'Cambiar logo',
  'wizard.logo.remove': 'Quitar logo',
  'upload.sending': 'Subiendo {file}',
  'upload.percent': '{percent, number, percent}',
  'upload.progress': 'Progreso de la subida',
  'upload.scanning': 'Analizando {file}: revisamos que el archivo sea seguro.',
  'upload.cancel': 'Cancelar',
  'upload.cancel.label': 'Cancelar la subida de {file}',
  'wizard.brand': 'Colores de marca',
  'wizard.brand.use': 'Usar los colores de la empresa',
  'wizard.brand.use.hint':
    'Opcional. Sin ellos, el portal y la consola de la empresa usan los de Eklevo. Nunca se ven en este panel ni en los correos.',
  'wizard.brand.primary': 'Color principal',
  'wizard.brand.accent': 'Color de acento',
  'wizard.brand.pick.primary': 'Elegir el color principal',
  'wizard.brand.pick.accent': 'Elegir el color de acento',
  'wizard.brand.hint': 'En formato #RRGGBB, como #1b2a4a.',
  'wizard.brand.contrast': 'Contraste',
  'wizard.brand.contrast.intro':
    'Cada uso de los colores tiene que leerse bien (WCAG 2.2). Unos colores que no cumplen una regla no se pueden guardar; con un aviso de diseño, sí.',
  'wizard.brand.rule.primary-text': 'Texto sobre el color principal',
  'wizard.brand.rule.primary-text-muted': 'Texto secundario sobre el color principal',
  'wizard.brand.rule.primary-text-hover': 'Texto de un botón principal con el puntero encima',
  'wizard.brand.rule.primary-ui': 'Color principal sobre las tarjetas y el fondo',
  'wizard.brand.rule.accent-text': 'Texto sobre el color de acento',
  'wizard.brand.rule.accent-text-hover': 'Texto de un botón de acento con el puntero encima',
  'wizard.brand.rule.accent-ui-primary': 'Botón de acento sobre el color principal',
  'wizard.brand.rule.accent-ui-surface': 'Botón de acento sobre una tarjeta blanca',
  'wizard.brand.check.passed': 'Cumple: {ratio} (mínimo {minimum})',
  'wizard.brand.check.failed': 'No cumple: {ratio} (mínimo {minimum})',
  'wizard.brand.check.warning':
    'Aviso de diseño: {ratio}, por debajo de {minimum}. Se puede guardar: el botón se lee por su texto, pero destaca menos.',
  'wizard.people.intro':
    'La lista de empleados la carga el equipo de RRHH desde su consola, en «Empleados y progreso» › «Importar CSV», con esta plantilla. Así, sus datos no pasan por el panel de Eklevo.',
  'wizard.people.columns':
    'Una persona por línea: el correo (obligatorio), el nombre y los apellidos y, si se quiere, el departamento, el equipo, el cargo, la fecha de incorporación, el idioma y el rol.',
  'wizard.people.invitations':
    'Las personas empleadas no reciben nada al crear la empresa: RRHH envía las invitaciones cuando lo decide.',
  'wizard.people.template': 'Descargar plantilla CSV',
  'wizard.people.templateFile': 'plantilla-empleados',
  'wizard.hr.heading': 'Designar responsables de RRHH',
  'wizard.hr.intro':
    'Estas personas recibirán un email de invitación a Eklevo. Al entrar, tendrán también la consola de RRHH.',
  'wizard.hr.person': 'Persona {count}',
  'wizard.hr.firstName': 'Nombre',
  'wizard.hr.lastName': 'Apellidos',
  'wizard.hr.email': 'Correo corporativo',
  'wizard.hr.email.hint':
    'El de una persona concreta, nunca un buzón compartido como rrhh@ o info@: cada acción de RRHH queda a nombre de quien la hace.',
  'wizard.hr.add': 'Añadir otra persona',
  'wizard.hr.remove': 'Quitar',
  'wizard.hr.removeLabel': 'Quitar a la persona {count}',
  'wizard.hr.max': 'Como mucho, 10 personas aquí; las demás, después, desde la consola de RRHH.',
  'wizard.notice.intro':
    'El aviso informativo de privacidad de la empresa: cada persona lo ve y confirma que lo ha leído en su primer acceso, y el correo de invitación enlaza su dirección. Sin aviso no sale ninguna invitación.',
  'wizard.notice.legend.es': 'Aviso en español',
  'wizard.notice.legend.ca': 'Aviso en catalán',
  'wizard.notice.legend.en': 'Aviso en inglés',
  'wizard.notice.default': 'Es el idioma de la empresa: este aviso es obligatorio.',
  'wizard.notice.add.es': 'Añadir también el aviso en español',
  'wizard.notice.add.ca': 'Añadir también el aviso en catalán',
  'wizard.notice.add.en': 'Añadir también el aviso en inglés',
  'wizard.notice.format': 'Formato del aviso',
  'wizard.notice.format.url': 'Enlace',
  'wizard.notice.format.text': 'Texto',
  'wizard.notice.url': 'Dirección del aviso',
  'wizard.notice.url.hint': 'Una página de la empresa, que empiece por https://.',
  'wizard.notice.body': 'Texto del aviso',
  'wizard.notice.body.count': '{count, number}/20.000 caracteres, con un mínimo de 20',
  'wizard.courses.intro':
    'Los cursos del catálogo de Eklevo con los que empieza la empresa. Quedan activados y «No lanzado»: RRHH decide cuándo lanzarlos y a quién asignarlos.',
  'wizard.courses.list': 'Cursos publicados del catálogo',
  'wizard.courses.optional': 'Opcional: también se pueden activar después, desde «Cursos».',
  'wizard.courses.count':
    '{count, plural, =0 {Ningún curso seleccionado} one {# curso seleccionado} other {# cursos seleccionados}}',
  'wizard.courses.empty':
    'Todavía no hay ningún curso publicado en el catálogo. Podrás activarlos después, desde «Cursos».',
  'wizard.summary.intro':
    'Revisa los datos antes de crear la empresa. Se crea todo a la vez, o nada.',
  'wizard.summary.edit.company': 'Editar los datos de la empresa',
  'wizard.summary.edit.hr': 'Editar el equipo de RRHH',
  'wizard.summary.edit.notice': 'Editar el aviso informativo',
  'wizard.summary.edit.courses': 'Editar los cursos',
  'wizard.summary.edit': 'Editar',
  'wizard.summary.brand.none': 'Los de Eklevo',
  'wizard.summary.logo.none': 'El de Eklevo',
  'wizard.summary.none': 'Sin indicar',
  'wizard.summary.people': 'Los carga RRHH desde su consola, con la plantilla.',
  'wizard.summary.notice.url': 'Enlace',
  'wizard.summary.notice.text':
    '{count, plural, one {Texto de # carácter} other {Texto de # caracteres}}',
  'wizard.summary.courses.none': 'Ninguno: se podrán activar después, desde «Cursos».',
  'wizard.summary.invitations':
    '{count, plural, one {Al crearla, la persona del equipo de RRHH recibirá la invitación.} other {Al crearla, las # personas del equipo de RRHH recibirán la invitación.}}',
  'wizard.create': 'Crear empresa',
  'wizard.create.busy': 'Creando la empresa…',
  'wizard.create.purpose': 'Crear la empresa {company}.',
  'wizard.error.required': 'Falta este dato.',
  'wizard.error.field': 'Revisa este dato.',
  'wizard.error.choice': 'Elige una de las opciones.',
  'wizard.error.name.too-short': 'Escribe al menos 2 caracteres.',
  'wizard.error.name.too-long': 'Como mucho, 120 caracteres.',
  'wizard.error.name.taken':
    'Ya hay una empresa con este nombre, también entre las dadas de baja. Elige otro.',
  'wizard.error.line.invalid-characters':
    'Tiene saltos de línea o caracteres invisibles que no se pueden usar.',
  'wizard.error.color.invalid': 'Escribe un color en formato #RRGGBB, como #1b2a4a.',
  'wizard.error.color.contrast':
    'Con el otro color, no cumple una regla de contraste: mira la lista de abajo.',
  'wizard.error.person.too-long': 'Como mucho, 100 caracteres.',
  'wizard.error.email.invalid': 'Escribe un correo válido.',
  'wizard.error.email.generic-mailbox':
    'Es un buzón compartido. Escribe el correo de una persona concreta.',
  'wizard.error.email.duplicate': 'Este correo ya está en el equipo.',
  'wizard.error.legalName.too-long': 'Como mucho, 200 caracteres.',
  'wizard.error.address.too-long': 'Como mucho, 300 caracteres.',
  'wizard.error.taxId.invalid': 'No tiene el formato de un CIF, NIF, NIE o NIF-IVA.',
  'wizard.error.taxId.taken':
    'Ya hay una empresa con este CIF/NIF, también entre las dadas de baja.',
  'wizard.error.hr.required': 'Añade al menos una persona.',
  'wizard.error.hr.too-many':
    'Como mucho, 10 personas. Las demás se añaden después, desde la consola de RRHH.',
  'wizard.error.notice.missing': 'Falta el aviso en el idioma de la empresa.',
  'wizard.error.notice.url': 'Escribe una dirección que empiece por https://.',
  'wizard.error.notice.too-short': 'Escribe al menos 20 caracteres.',
  'wizard.error.notice.too-long': 'Como mucho, 20.000 caracteres.',
  'wizard.error.notice.invalid-characters': 'Tiene caracteres invisibles que no se pueden usar.',
  'wizard.error.notice.placeholder':
    'Este texto aún tiene marcadores del modelo sin rellenar: {placeholders}.',
  'wizard.error.courses.too-many': 'Como mucho, 50 cursos.',
  'wizard.error.course.not-available':
    'Este curso ya no se puede activar: quítalo para crear la empresa.',
  'wizard.error.logo.uploading': 'Espera a que termine la subida del logo, o cancélala.',
  'wizard.error.logo.scanning':
    'Todavía se está revisando el logo. Espera un momento y vuelve a intentarlo.',
  'wizard.error.logo.too-large': 'El logo supera 1 MB.',
  'wizard.error.logo.empty': 'El archivo está vacío.',
  'wizard.error.logo.wrong-type': 'El logo tiene que ser una imagen PNG o JPEG.',
  'wizard.error.logo.wrong-dimensions':
    'El logo tiene que medir entre 32 y 4.000 píxeles por lado.',
  'wizard.error.logo.infected':
    'La revisión de seguridad ha encontrado un problema en el archivo, y no se ha subido.',
  'wizard.error.logo.scan-failed': 'No se ha podido revisar el archivo. Prueba con otro.',
  'wizard.error.logo.missing': 'El archivo no ha llegado entero. Vuelve a subirlo.',
  'wizard.error.logo.expired': 'La subida del logo ha caducado. Vuelve a subirlo.',
  'wizard.error.logo.network': 'Se ha perdido la conexión mientras se subía. Vuelve a subirlo.',
  'wizard.error.logo.scan-timeout':
    'La revisión del archivo está tardando demasiado. Vuelve a subirlo más tarde.',
  'wizard.error.logo.failed': 'No se ha podido subir el logo. Vuelve a intentarlo.',
  'wizard.error.rateLimited':
    'Has hecho demasiados intentos de crear empresas. Espera un rato y vuelve a intentarlo: lo que has escrito sigue aquí mientras no cierres la pestaña.',
  'wizard.error.generic':
    'No se ha podido crear la empresa. Vuelve a intentarlo en unos minutos: lo que has escrito sigue aquí.',
  'reauth.title': 'Confirma que eres tú',
  'reauth.body':
    'Esta acción necesita tu clave de acceso: la huella, la cara o el PIN de tu dispositivo.',
  'reauth.confirm': 'Usar mi clave de acceso',
  'reauth.busy': 'Esperando a tu clave de acceso…',
  'idle.title': '¿Sigues ahí?',
  'idle.body':
    'Por seguridad, la sesión se cierra tras 30 minutos sin actividad. Se cerrará a las {at, time, short}.',
  'idle.stay': 'Mantener la sesión',
  'ending.notice':
    'Tu sesión termina a las {endsAt, time, short}, al llegar a las 8 horas. Después tendrás que volver a entrar.',
} as const

export type BackOfficeMessageKey = keyof typeof es
export type BackOfficeCatalog = Record<BackOfficeMessageKey, string>
